var t = function t(_t, e) {
  this.key = _t, this.value = e;
};
t.prototype.assert = function (t, e) {
  if (void 0 === e && (e = "Assert failed for key: '" + this.key + "' and value:" + this.value), t(this.value)) return this;
  throw new Error(e instanceof Function ? e(this.value, this.key) : e);
}, t.prototype.transform = function (t) {
  return this.value = t(this.value), this;
}, t.prototype.asEnum = function (t) {
  var e = this;
  return this.assert(function (e) {
    return t.includes(e);
  }, function () {
    return 'The key "' + e.key + '" must be one of: ' + t;
  });
}, t.prototype.asRegex = function (t) {
  var e = this;
  return this.assert(function (e) {
    return t.test(e.toString());
  }, function () {
    return 'The key "' + e.key + '" must match the regex: ' + t;
  });
}, t.prototype.asLowerCase = function () {
  return this.transform(function (t) {
    return t.toString().toLowerCase();
  });
}, t.prototype.asUpperCase = function () {
  return this.transform(function (t) {
    return t.toString().toUpperCase();
  });
}, t.prototype.asBoolean = function () {
  return this.asLowerCase().asEnum(["false", "0", "true", "1"]).transform(function (t) {
    return "true" === t || "1" === t;
  });
}, t.prototype.asInt = function () {
  return this.transform(function (t) {
    return parseFloat(t.toString());
  }).assert(function (t) {
    return Number.isInteger(t);
  }, 'The key "' + this.key + '" must be a valid integer');
}, t.prototype.asFloat = function () {
  return this.transform(function (t) {
    return parseFloat(t.toString());
  }).assert(function (t) {
    return !isNaN(t);
  }, 'The key "' + this.key + '" must be a valid float');
}, t.prototype.greater = function (t) {
  return ("number" == typeof this.value ? this : this.asFloat()).assert(function (e) {
    return e > t;
  }, 'The key "' + this.key + '" must be greater than ' + t);
}, t.prototype.greaterOrEqual = function (t) {
  return ("number" == typeof this.value ? this : this.asFloat()).assert(function (e) {
    return e >= t;
  }, 'The key "' + this.key + '" must be greater than or equal to ' + t);
}, t.prototype.less = function (t) {
  return ("number" == typeof this.value ? this : this.asFloat()).assert(function (e) {
    return e < t;
  }, 'The key "' + this.key + '" must be less than ' + t);
}, t.prototype.lessOrEqual = function (t) {
  return ("number" == typeof this.value ? this : this.asFloat()).assert(function (e) {
    return e <= t;
  }, 'The key "' + this.key + '" must be less than or equal to ' + t);
}, t.prototype.asJson = function () {
  var t = this;
  return this.transform(function (e) {
    try {
      return JSON.parse(e.toString());
    } catch (e) {
      return t.assert(function () {
        return !1;
      }, 'The key "' + t.key + '" must be a valid JSON');
    }
  });
}, t.prototype.asJsonArray = function () {
  return this.asJson().assert(function (t) {
    return Array.isArray(t);
  }, 'The key "' + this.key + '" must be a valid JSON array');
}, t.prototype.asPort = function () {
  return this.asInt().greaterOrEqual(0).lessOrEqual(65535);
};
export default function (e, r, n) {
  var s = process.env[e];
  if (void 0 !== n || void 0 === r || r instanceof Function && 1 === r.length || (n = r, r = void 0), void 0 === s) {
    if (void 0 === n) throw new Error("Key: " + e + " does not exists.");
    return n instanceof Function ? n() : n;
  }
  return r ? r(new t(e, s)).value : s;
}